export default "__VITE_ASSET__C5PHAl1a__"